import type { Command } from '@atlaskit/editor-common/types/command';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { AlignmentValue, NativeEmbedParameters } from '@atlaskit/native-embeds-common/types';
import { getParameters, setParameter } from '@atlaskit/native-embeds-common/utils';

import type { EditorPluginNativeEmbedsPlugin } from '../../nativeEmbedsPluginType';
import type { ExtensionDocUpdateOpts } from './types';

export const getAlignment = (selectedNode: PMNode): AlignmentValue => {
	return getParameters(selectedNode.attrs.parameters, 'alignment');
};

export const createUpdateAlignmentCommand =
	(
		api: ExtractInjectionAPI<EditorPluginNativeEmbedsPlugin> | undefined,
		alignment: AlignmentValue,
		selectedNode: PMNode,
		opts?: ExtensionDocUpdateOpts,
	): Command =>
	() => {
		api?.extension?.actions?.api()?.doc?.update(
			selectedNode.attrs.localId,
			(current) => ({
				attrs: {
					...current.attrs,
					parameters: setParameter(current.attrs?.parameters as NativeEmbedParameters | undefined, {
						alignment,
					}),
				},
			}),
			opts,
		);

		return true;
	};
